import { useEffect, useState } from "react";
import { StepDTO } from "react-form-stepper/dist/components/Step/StepTypes";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useCreateCompanyMutation } from "../../API/authApi";
import { ICreateBusinessForm } from "../../Interfaces/formValue-interfaces";
import { BusinessTypes, CustomerCount, IAutocompleteItem, IBusinessTypesContent, ImageTypes } from "../../Interfaces/componentTypes";
import { ICreateBusinessData } from "../../Interfaces/request-interfaces";
import useUploadFile from "../FileUploader/fileUploader-hooks";
import { useGeneralHooks, useToastify } from "../../Hooks/hooks";
import { Cafe, Shop, CoffeeCup, FastFood, Hotel, Pizza, Restaurant } from "../../Assets/Images";


const useCreateBusiness = () => {
    const { navigate, t } = useGeneralHooks();
    const steps: StepDTO[] = [{ label: t('Business.Step_1.Title') }, { label: t('Business.Step_2.Title') }, { label: t('Business.Step_3.Title') }];
    const [createCompany, { data: companyResponse, isLoading: companyLoading, isSuccess: isCompaneCreated, isError: isCompanyCreatedError }] = useCreateCompanyMutation();
    const [businessType, setBusinessType] = useState<BusinessTypes | null>(null);
    const { register, control, handleSubmit, formState: { errors, isValid }, setValue } = useForm<ICreateBusinessForm>({ mode: 'all' });
    const [activeStep, setActiveStep] = useState<number>(0);
    const { showToastError } = useToastify();
    const [country, setCountry] = useState<string | null>(null);
    const companyId = companyResponse?.id!;
    const onNextStep = () => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    const onPrevStep = () => setActiveStep((prev) => Math.max(prev - 1, 0));
    const { imageUrl, handleFileInputChange, ImageResponce, imageLoadingSuccess, imageLoading, imageLoadingError } = useUploadFile(ImageTypes.LOGO);
    const onSetBusinessType = (type: BusinessTypes) => {
        setBusinessType(type);
        onNextStep()
    };

    const businessTypeContnents: IBusinessTypesContent[] = [
        {
            title: t('Business_Types.restaurant'),
            icon: Restaurant,
            value: BusinessTypes.RESTAURANT
        },
        {
            title: t('Business_Types.cafe'),
            icon: Cafe,
            value: BusinessTypes.CAFE
        },
        {
            title: t('Business_Types.fast_food'),
            icon: FastFood,
            value: BusinessTypes.FAST_FOOD
        },
        {
            title: t('Business_Types.shop'),
            icon: Shop,
            value: BusinessTypes.SHOP
        },
        {
            title: t('Business_Types.pizzeria'),
            icon: Pizza,
            value: BusinessTypes.PIZZERIA
        },
        {
            title: t('Business_Types.hotel'),
            icon: Hotel,
            value: BusinessTypes.HOTEL
        },
        {
            title: t('Business_Types.coffee_shop'),
            icon: CoffeeCup,
            value: BusinessTypes.COFFEE_SHOP
        },

    ];

    const onSubmit: SubmitHandler<ICreateBusinessForm | FieldValues> = (values) => {
        const payload: ICreateBusinessData = {
            name: (values.name as string).trim(),
            type: businessType!,
            customer_count: (values.customer_count as IAutocompleteItem).id as CustomerCount,
            country: values.country,
            city: values.city,
            logo: ImageResponce?.src!,
        };
        createCompany(payload)
    };

    const onVisitBusinessSite = () => {
        navigate(`/my_business/${companyId}`)
    };

    useEffect(() => {
        imageLoadingError &&
            showToastError('Something went wrong')
    }, [imageLoadingError]);

    useEffect(() => {
        isCompanyCreatedError &&
            showToastError('Something went wrong')
    }, [isCompanyCreatedError]);


    return {
        steps,
        errors,
        country,
        control,
        isValid,
        imageUrl,
        activeStep,
        imageLoading,
        companyLoading,
        isCompaneCreated,
        imageLoadingSuccess,
        businessTypeContnents,
        setValue,
        register,
        onSubmit,
        onNextStep,
        setCountry,
        onPrevStep,
        handleSubmit,
        onSetBusinessType,
        onVisitBusinessSite,
        handleFileInputChange,
    }
};

export default useCreateBusiness